import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-store",
  "use": "icon-store-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64 64\" id=\"icon-store\">\r\n<path d=\"M59.037,4.963H4.963v6.759h54.074V4.963z M62.416,38.76V32l-3.379-16.898H4.963L1.584,32v6.76h3.379v20.277H38.76V38.76\r\n\th13.518v20.277h6.76V38.76H62.416z M32,52.277H11.723V38.76H32V52.277z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/store.svg
// module id = Lta+
// module chunks = 31